import { selectFeaturedPoiIds, fetchFeaturedPois, selectFeaturedPoiById } from './poisSlice';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PoiList from './PoiList';
import Navbar from '../../app/Navbar';
import { useHistory } from 'react-router-dom';



const FeaturedPoisPage = () => {
    const poiIds = useSelector(selectFeaturedPoiIds);
    const poiStatus = useSelector(state => state.pois.featuredPois.status);
    const error = useSelector((state) => state.pois.featuredPois.error);
    const history = useHistory();
    const goBack = (event) => {
        event.preventDefault();
        history.goBack();
    };
    const dispatch = useDispatch();
    useEffect(() => {
        if (poiStatus === 'idle') {
            dispatch(fetchFeaturedPois());
        }
    }, [poiStatus, dispatch]);

    return <div id="search_poi_page">
        <PoiList poiIds={poiIds} status={poiStatus} error={error} onGoBack={goBack} selectById={selectFeaturedPoiById}/>
        <Navbar/>
    </div>
};

export default FeaturedPoisPage;